
document.addEventListener("DOMContentLoaded", function () {

  function updateButtons() {
    let addToCartBtn    = document.querySelector(".m-add-to-cart");
    let buyNowBtn       = document.querySelector("#gokwik-buy-now");
    let checkoutWrapper = document.querySelector(".m-product-dynamic-checkout.show-add-to-cart");
    let notifyContainer = document.querySelector(".manifest-button__container");
    let soldOutText     = addToCartBtn?.querySelector(".m-add-to-cart--text");

    if (!addToCartBtn || !buyNowBtn || !notifyContainer || !checkoutWrapper) return;

    // Variant availability
    let isAvailable = !addToCartBtn.classList.contains("disabled");

    if (isAvailable) {
      // PRODUCT IN STOCK
      addToCartBtn.style.display    = "block";
      buyNowBtn.style.display       = "block";
      notifyContainer.style.display = "none";

      // Reset sold-out text
      if (soldOutText) soldOutText.textContent = "Add to Cart";

      // Reset margin fix
      checkoutWrapper.style.marginTop = "";
    } 
    else {
      // PRODUCT SOLD OUT
      addToCartBtn.style.display    = "block";
      buyNowBtn.style.display       = "none";   // Hide Buy Now
      notifyContainer.style.display = "flex";

      if (soldOutText) soldOutText.textContent = "Sold Out";

      // APPLY MARGIN FIX WHEN BUY NOW IS HIDDEN
      checkoutWrapper.style.marginTop = "0px";
    }
  }

  // Initial load
  setTimeout(updateButtons, 600);

  // Variant changes
  document.body.addEventListener("change", () => setTimeout(updateButtons, 150));
  document.body.addEventListener("click", () => setTimeout(updateButtons, 150));

});

